import { UserBadge } from "@/components/UserBadge";
import { FlexDiv } from "@repo/ui";

import { CalendarTime, CalendarTitle } from "../components/CalendarAppointment";
import { OverflowContainer } from "../components/OverflowContainer";
import { type CoWorkerCalendarItem } from "../types";

export const ShortWeekCalendarAppointment = ({
  item,
  overlapping,
  showInitials,
}: {
  item: CoWorkerCalendarItem;
  overlapping: boolean;
  showInitials?: boolean;
}) => {
  return (
    <FlexDiv justifyContent="space-between" alignItems="center">
      <OverflowContainer>
        <CalendarTitle item={item} />
      </OverflowContainer>

      {!overlapping && <CalendarTime item={item} />}
      {showInitials && <UserBadge email={item.emailId} small />}
    </FlexDiv>
  );
};
